import { render, staticRenderFns } from "./StartupsByRegionChart.vue?vue&type=template&id=3549a154&"
import script from "./StartupsByRegionChart.vue?vue&type=script&lang=js&"
export * from "./StartupsByRegionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports